import { Card, CardContent, CardHeader, Skeleton } from '@packages/shared';
import { forwardRef } from 'react';
import { RecoProductCardSkeleton } from '../RecoProductCardSkeleton';

/**
 * This component can be used to display a skeleton for the recommendations carousel.
 */
export const RecoCarouselSkeleton = forwardRef<HTMLDivElement, {}>((_, ref) => (
  <Card ref={ref}>
    <CardHeader
      title={<Skeleton variant="text" width="15%" />}
      sx={{
        borderBottom: 1,
        borderColor: 'grey.main',
        py: 1,
        px: 2,
      }}
    />
    <CardContent
      sx={{
        display: 'flex',
        gap: 1.5,
      }}
    >
      <RecoProductCardSkeleton />
    </CardContent>
  </Card>
));
